module.exports = __webpack_public_path__ + "img/finance-application-mitsu.4ffc355e.png";